import { mapKeysToCamelCase } from '@skytech/utils'

import { API_ROUTE_ADMIN_REPORTS } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { ReportFilters } from './types'

type SalaryDeductionUsageReportOriginal = {
  employee_no: string
  name: string
  accounting_code: string
  benefit_mobile: 'f' | 'n' | 'w' | 'c'
  benefit_mobile_ceiling: string | null
  department_code: string
  department_name: string
  customer_head_id: number
  dim1: null | string
  dim2: null | string
  dim3: null | string
  dim4: null | string
  invoice_date: string
  invoice_no: string
  order_date: string | null
  currency: string | null
  fixed_salary_deduction_amount: number
  amount: number
  vat: number | null
  net_vat: number
  net_no_vat: number
  delivery_date: string | null
  project_usage: string
  posts: number
  org_no: string
  customer_name: string
  accounting_code_cost_object: string
}

const IS_NEW_BACKEND_API = true

export const getSalaryDeductionUsageReports = async ({
  selectedReportType,
  toDate,
  fromDate,
  isGlobal,
  selectedCustomer,
}: ReportFilters) => {
  if (!fromDate || !toDate) throw Error('Missing date range filters!')

  const searchParams = new URLSearchParams()
  searchParams.append('fromDate', fromDate)
  searchParams.append('toDate', toDate)
  searchParams.append('isGlobal', isGlobal.toString())
  searchParams.append('customerId', String(selectedCustomer || ''))

  const reports = await get<SalaryDeductionUsageReportOriginal[]>(
    `${API_ROUTE_ADMIN_REPORTS}/${selectedReportType}?${searchParams.toString()}`,
    IS_NEW_BACKEND_API
  )
  return mapKeysToCamelCase(reports)
}
